import initToast from './toast';
import initLottie from './lottie';
import initNumberBtn from './number-btn';
import { get } from './ajax';

const flyout = document.getElementById('flyout');
const flyouts = document.querySelectorAll('[data-toggle="flyout"]');

function markFlyoutCard(el) {
  flyouts.forEach((flyoutEl) => {
    flyoutEl.closest('.card').classList.remove('selected');
  });

  el.closest('.card').classList.add('selected');
}

function initFlyoutClose(el) {
  const duration = 400;
  const close = flyout.getElementsByClassName('btn-close')[0];

  if (close) {
    close.addEventListener('click', (event) => {
      event.preventDefault();

      flyout.classList.add('animated');
      flyout.classList.remove('show');
      el.parentElement.classList.remove('selected');

      window.setTimeout(() => {
        flyout.classList.remove('animated');
      }, duration);
    });
  }
}

function showFlyoutCard(el) {
  const duration = 400;

  initToast();
  initLottie();
  initNumberBtn();
  initFlyoutClose(el);

  flyout.classList.add('animated');
  flyout.classList.toggle('show');

  window.setTimeout(() => {
    flyout.classList.remove('animated');
  }, duration);
}

export default function initFlyout() {
  if (flyout) {
    flyouts.forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault();

        markFlyoutCard(el);

        if (el.dataset.page) {
          get(el.dataset.page, (data) => {
            flyout.innerHTML = data;

            showFlyoutCard(el);
          });
        } else {
          showFlyoutCard(el);
        }
      });
    });
  }
}
